/**
 * 数据大屏接口
 * @author： xuyd
 * @date：2024-05-05
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 检索大屏列表
   */
  searchScreenList: (params) => {
    return request.post(serviceModule + "/datavisual/screen/search", params);
  },

  /**
   * 保存大屏信息
   */
  getScreenInfo: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/datavisual/screen/info/get", {params});
  },

  /**
   * 保存大屏信息
   */
  saveScreen: (params) => {
    return request.post(serviceModule + "/datavisual/screen/info/save", params);
  },

  /**
   * 删除大屏
   * @param id 大屏id
   */
  deleteScreen: (id) => {
    return request.get(serviceModule + "/datavisual/screen/delete?id=" + id);
  },

  /////////////////////////////////////////////////////////////////////////////////////

  /**
   * 检索大屏组件列表
   * @param pageId 大屏id
   */
  selectWidgetList: (pageId) => {
    let params = {pageId: pageId}
    return request.get(serviceModule + "/datavisual/screen/widget/select", {params});
  },

  /**
   * 查询大屏组件内容，比如重新加载该组件
   * @param id
   */
  reload: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/datavisual/screen/widget/reload", {params});
  },

  /**
   * 添加大屏组件
   * @param params
   */
  addWidget: (params) => {
    return request.post(serviceModule + "/datavisual/screen/widget/add", params);
  },

  /**
   * 更新大屏组件
   *
   * @param params
   */
  updateWidgetList: (params) => {
    return request.post(serviceModule + "/datavisual/screen/widget/update", params);
  },
  /**
   * 删除大屏组件内容
   *
   * @param id
   */
  deleteWidget: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/datavisual/screen/widget/delete", {params});
  },

}
